module.exports = __webpack_public_path__ + "static/media/back-line-vector.faedb1db.png";